/* tslint:disable */

declare var Object: any;
export interface VehiclePictureInterface {
  "name": string;
  "displayName": string;
  "required": boolean;
  "id"?: any;
}

export class VehiclePicture implements VehiclePictureInterface {
  "name": string;
  "displayName": string;
  "required": boolean;
  "id": any;
  constructor(data?: VehiclePictureInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VehiclePicture`.
   */
  public static getModelName() {
    return "VehiclePicture";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VehiclePicture for dynamic purposes.
  **/
  public static factory(data: VehiclePictureInterface): VehiclePicture{
    return new VehiclePicture(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VehiclePicture',
      plural: 'VehiclePictures',
      path: 'VehiclePictures',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
        "required": {
          name: 'required',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
